module.exports = __webpack_public_path__ + "img/success.eeba6409.png";